/**
 * @packageDocumentation
 *
 * @example
 * ```
 * import { api } from "@rlx/feim"
 *
 * api.send.balanceUpdate(500)
 *
 * api.on.refreshBalance(() => {
 *  // Refresh it
 * })
 * ```
 */

import { removeHandler } from "./registerEventHandler";

/**
 * Remove all handlers using this callback
 * @param callbackToRemove - All existing handlers using this callback will be removed
 */
export const remove = (callbackToRemove: (callbackToRemove: unknown) => unknown): void =>
{
    removeHandler(callbackToRemove);
};

export * as send from "./send";
export * as on from "./on";
export * as P2P from "./P2P";